module.exports = __webpack_public_path__ + "img/kuaishou.77946ba9.png";